import * as React from 'react';

import { Box, Skeleton } from '@moosend/mooskin';
import { Link } from 'react-router-dom';

interface IStatBox {
	title: string;
	link: string;
	active: boolean;
	disabled: boolean;
	counter: number;
	color?: string;
	isLoaded?: boolean;
}

export const TableTab: React.FC<IStatBox> = (props) => {
	return (
		<Link to={props.link} style={props.disabled ? { pointerEvents: 'none' } : undefined}>
			<Box
				minW="175px"
				h="100%"
				d="flex"
				minH={60}
				border="1px solid"
				borderBottom="none"
				borderColor="borderColors.gray1"
				mx={2.5}
				align="start"
				p="10px 15px"
				bgColor={props.active ? 'backgroundColors.white' : 'backgroundColors.gray2'}
				opacity={!props.disabled ? 1 : 0.4}
				direction="column"
				borderRadius="3px 3px 0 0"
				justify="flex-start"
			>
				<Box fontSize="12px" fontWeight="bold" lineHeight="1.25" fontColor={props.color ?? 'fontColors.text'}>
					{props.title}
				</Box>
				<Box textAlign="right" fontSize="12px" fontWeight={500} fontColor="fontColors.primary2">
					<Skeleton isLoaded={props.isLoaded}>{props.counter}</Skeleton>
				</Box>
				<Box textAlign="right" fontSize="12px" fontWeight={500} fontColor="fontColors.primary2">
					<Skeleton isLoaded={props.isLoaded}>{props.children}</Skeleton>
				</Box>
			</Box>
		</Link>
	);
};
